// input
import FirstName from "@/components/form-fields/first-name/Index.vue";
import LastName from "@/components/form-fields/last-name/Index.vue";
import Address from "@/components/form-fields/address/Index.vue";
import AddressLine1 from "@/components/form-fields/address/Index.vue";
import AddressLine2 from "@/components/form-fields/address/Index.vue";
import City from "@/components/form-fields/city/Index.vue";
import Company from "@/components/form-fields/company/Index.vue";
import DealerEmail from "@/components/form-fields/dealer-email/Index.vue";
import Email from "@/components/form-fields/email/Index.vue";
import EmailCaptcha from "@/components/form-fields/email-captcha/Index.vue";
import InvoiceNumber from "@/components/form-fields/invoice-number/Index.vue";
import Message from "@/components/form-fields/message/Index.vue";
import ModelNumber from "@/components/form-fields/model-number/Index.vue";
import Phone from "@/components/form-fields/phone/Index.vue";
import PostalCode from "@/components/form-fields/postal-code/Index.vue";
import PurchaseLocation from "@/components/form-fields/purchase-location/Index.vue";
import SerialNumber from "@/components/form-fields/serial-number/Index.vue";
import OrderNumber from "@/components/form-fields/order-number/Index.vue";
import Others from '@/components/form-fields/others/Index.vue';
import DealerPhone from '@/components/form-fields/dealer-phone/Index.vue';
import InvoiceAmount from '@/components/form-fields/invoice-amount/Index.vue';
import MiddleName from '@/components/form-fields/middle-name/Index.vue';
import ProductPrice from '@/components/form-fields/product-price/Index.vue';
import PromoCode from '@/components/form-fields/promo-code/Index.vue';
import PromotionReason from '@/components/form-fields/promotion-reason/Index.vue';
import Password from "@/components/form-fields/password/Index.vue";
import RetypePassword from "@/components/form-fields/retype-password/Index.vue";
import State from  "@/components/form-fields/last-name/Index.vue";
import Brand from  "@/components/form-fields/last-name/Index.vue";

// select
import Campaign from "@/components/form-fields/campaign/Index.vue";
import Category from "@/components/form-fields/category/Index.vue";
import StateProvince from "@/components/form-fields/state-province/Index.vue";
import ProductBrand from "@/components/form-fields/product-brand/Index.vue";
import PurchaseType from "@/components/form-fields/purchase-type/Index.vue";
import SubCategory from "@/components/form-fields/sub-category/Index.vue";
import ServiceTime from "@/components/form-fields/service-time/Index.vue";
import usageTime from "@/components/form-fields/usage-time/Index.vue";
import PurchaseReason from "@/components/form-fields/purchase-reason/Index.vue";
import PurchaseLocationOption from "@/components/form-fields/purchase-location-option/Index.vue";
import PromotionChannel from "@/components/form-fields/promotion-channel/Index.vue";
import IssueType from "@/components/form-fields/issue-type/Index.vue";

// date
import PurchaseDate from "@/components/form-fields/purchase-date/Index.vue";
import DeliveryDate from "@/components/form-fields/delivery-date/Index.vue";
import ReservationDate from "@/components/form-fields/reservation-date/Index.vue";
import InstallationDate from "@/components/form-fields/installation-date/Index.vue";
import Birthday from "@/components/form-fields/birthday/Index.vue";

// upload
import InvoiceReceipt from "@/components/form-fields/invoice-receipt/Index.vue";
import WarrantyCard from "@/components/form-fields/warranty-card/Index.vue";

// 涉及接口的字段
import Country from "@/components/form-fields/country/Index.vue";
import ManualCountry from "@/components/form-fields/country/Index.vue";

// policy
import PrivacyPolicy from "@/components/form-policy/privacy-policy/Index.vue";
import MarketingOptIn from "@/components/form-policy/marketing-opt-in/Index.vue";
import OptIn from "@/components/form-policy/opt-in/Index.vue";

// action
import SubmitButton from "@/components/form-action/submit-button/Index.vue";
// variants
import ProductVariantsV1 from "@/components/product/variants/v1/Index.vue";
// DISCOUNT
import ThreeInOnePrice from "@/components/three-in-one/toshiba/price/v1/Index.vue";
import {
    // input
    __CMP_FIRST_NAME__,
    __CMP_LAST_NAME__,
    __CMP_ADDRESS__,
    __CMP_ADDRESS_LINE1__,
    __CMP_ADDRESS_LINE2__,
    __CMP_CITY__,
    __CMP_COMPANY__,
    __CMP_DEALER_EMAIL__,
    __CMP_EMAIL__,
    __CMP_EMAIL_CAPTCHA__,
    __CMP_INVOICE_NUMBER__,
    __CMP_MESSAGE__,
    __CMP_MODEL_NUMBER__,
    __CMP_PHONE__,
    __CMP_POSTAL_CODE__,
    __CMP_PURCHASE_LOCATION__,
    __CMP_SERIAL_NUMBER__,
    __CMP_ORDER_NUMBER__,
    __CMP_OTHERS__,
    __CMP_MIDDLE_NAME__,
    __CMP_PRODUCT_PRICE__,
    __CMP_INVOICE_AMOUNT__,
    __CMP_DEALER_PHONE__,
    __CMP_PROMO_CODE__,
    __CMP_PROMOTION_REASON__,
    __CMP_PASSWORD__,
    __CMP_RETYPE_PASSWORD__,
    __CMP_STATE__,
    __CMP_BRAND__,

    // select
    __CMP_CATEGORY__,
    __CMP_STATE_PROVINCE__,
    __CMP_PRODUCT_BRAND__,
    __CMP_PURCHASE_TYPE__,
    __CMP_SUB_CATEGORY__,
    __CMP_SERVICE_TIME__,
    __CMP_USAGE_TIME__,
    __CMP_PURCHASE_REASON__,
    __PURCHASE_LOCATION_OPTION__,
    __PROMOTION_CHANNEL__,
    __CMP_ISSUE_TYPE__,

    // date
    __CMP_PURCHASE_DATE__,
    __CMP_DELIVERY_DATE__,
    __CMP_RESERVATION_DATE__,
    __CMP_INSTALLATION_DATE__,
    __CMP_BIRTHDAY__,

    // upload
    __CMP_INVOICE_RECEIPT__,
    __CMP_WARRANTY_CARD__,

    // 涉及接口的字段
    __CMP_COUNTRY__,
    __CMP_MANUAL_COUNTRY__,
    __CMP_CAMPAIGN__,

    // policy
    __CMP_PRIVACY_POLICY__,
    __CMP_MARKETING_OPT_IN__,
    __CMP_OPT_IN__,

    // action
    __CMP_SUBMIT_BUTTON__,
    __CMP_PRODUCT_VARIANTS_V1__,
    __CMP__TOSHIBA_COMMERCE_PRICE__,
} from "@/const/csrCmpName.js";

const csrCmpSet = {
    // input
    [__CMP_FIRST_NAME__]: FirstName,
    [__CMP_LAST_NAME__]: LastName,
    [__CMP_ADDRESS__]: Address,
    [__CMP_ADDRESS_LINE1__]: AddressLine1,
    [__CMP_ADDRESS_LINE2__]: AddressLine2,
    [__CMP_CITY__]: City,
    [__CMP_COMPANY__]: Company,
    [__CMP_DEALER_EMAIL__]: DealerEmail,
    [__CMP_EMAIL__]: Email,
    [__CMP_EMAIL_CAPTCHA__]: EmailCaptcha,
    [__CMP_INVOICE_NUMBER__]: InvoiceNumber,
    [__CMP_MESSAGE__]: Message,
    [__CMP_MODEL_NUMBER__]: ModelNumber,
    [__CMP_PHONE__]: Phone,
    [__CMP_POSTAL_CODE__]: PostalCode,
    [__CMP_PURCHASE_LOCATION__]: PurchaseLocation,
    [__CMP_SERIAL_NUMBER__]: SerialNumber,
    [__CMP_ORDER_NUMBER__]: OrderNumber,
    [__CMP_OTHERS__]: Others,
    [__CMP_MIDDLE_NAME__]: MiddleName,
    [__CMP_PRODUCT_PRICE__]: ProductPrice,
    [__CMP_INVOICE_AMOUNT__]: InvoiceAmount,
    [__CMP_DEALER_PHONE__]: DealerPhone,
    [__CMP_PROMO_CODE__]: PromoCode,
    [__CMP_PROMOTION_REASON__]: PromotionReason,
    [__CMP_PASSWORD__]: Password,
    [__CMP_RETYPE_PASSWORD__]: RetypePassword,
    [__CMP_STATE__]: State,
    [__CMP_BRAND__]: Brand,

    // select
    [__CMP_CATEGORY__]: Category,
    [__CMP_STATE_PROVINCE__]: StateProvince,
    [__CMP_PRODUCT_BRAND__]: ProductBrand,
    [__CMP_PURCHASE_TYPE__]: PurchaseType,
    [__CMP_SUB_CATEGORY__]: SubCategory,
    [__CMP_SERVICE_TIME__]: ServiceTime,
    [__CMP_USAGE_TIME__]: usageTime,
    [__CMP_PURCHASE_REASON__]: PurchaseReason,
    [__PURCHASE_LOCATION_OPTION__]: PurchaseLocationOption,
    [__PROMOTION_CHANNEL__]: PromotionChannel,
    [__CMP_ISSUE_TYPE__]: IssueType,

    // date
    [__CMP_PURCHASE_DATE__]: PurchaseDate,
    [__CMP_DELIVERY_DATE__]: DeliveryDate,
    [__CMP_RESERVATION_DATE__]: ReservationDate,
    [__CMP_INSTALLATION_DATE__]: InstallationDate,
    [__CMP_BIRTHDAY__]: Birthday,

    // upload
    [__CMP_INVOICE_RECEIPT__]: InvoiceReceipt,
    [__CMP_WARRANTY_CARD__]: WarrantyCard,

    // 涉及接口的字段
    [__CMP_COUNTRY__]: Country,
    [__CMP_MANUAL_COUNTRY__]: ManualCountry,
    [__CMP_CAMPAIGN__]: Campaign,

    // policy
    [__CMP_PRIVACY_POLICY__]: PrivacyPolicy,
    [__CMP_MARKETING_OPT_IN__]: MarketingOptIn,
    [__CMP_OPT_IN__]: OptIn,

    // action
    [__CMP_SUBMIT_BUTTON__]: SubmitButton,

    // product
    [__CMP_PRODUCT_VARIANTS_V1__]: ProductVariantsV1,
    // DISCOUNT
    [__CMP__TOSHIBA_COMMERCE_PRICE__]:ThreeInOnePrice
    
};

export default csrCmpSet;